module.exports = __webpack_public_path__ + "img/user-icon.773223fc.svg";